import { lazyNamed } from 'src/utils/lazyNamed';

export const AdMediaList = lazyNamed(() => import('./containers/AdMediaList/index.tsx'), 'AdMediaList');
export const AdMediaForm = lazyNamed(() => import('./containers/AdMediaForm/index.tsx'), 'AdMediaForm');
export const AdMediaHistory = lazyNamed(() => import('./containers/AdMediaHistory/index.tsx'), 'AdMediaHistory');
export { AdPrice } from './containers/AdPrices';
export { AdTypes } from './containers/AdTypes';
export { Placement } from './containers/Placements';
export { Products } from './containers/Products';
export { AdMediumMapping } from './containers/AdMediumMapping';

export const Layout = lazyNamed(() => import('./components/Layout'), 'Layout');
